import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, Table } from 'react-bootstrap';
import moment from 'moment';
import LoaderButton from '../components/LoaderButton';
import { CreateLocationRoutes, OpsLocations } from '../libs/GraphQL';
import { uploadFileToS3 } from '../libs/uploadToS3';

export default class ChangeWeeklyRoutes extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: false,
      fileContents: '',
      locations: [],
    };
    this.getOpsLocations = this.getOpsLocations.bind(this);
    this.makeChanges = this.makeChanges.bind(this);
    this.validateline = this.validateline.bind(this);
    this.validateFile = this.validateFile.bind(this);
    this.getLocationType = this.getLocationType.bind(this);
    this.isValidDateTime = this.isValidDateTime.bind(this);
  }

  async componentDidMount() {
    try {
      this.getOpsLocations();
    } catch (e) {
      console.error(e);
    }
  }

  async getOpsLocations() {
    const allLocations = [];
    let nextToken = null;

    do {
      const response = await OpsLocations({
        nextToken,
        status: ['LIVE'],
      });
      if (response?.data?.opsLocations) {
        const locations = response.data.opsLocations.locations || [];
        allLocations.push(...locations);
      }
      nextToken = response?.data?.opsLocations?.nextToken;
    } while (nextToken);

    this.setState({
      locations: allLocations,
    });
  }

  async makeChanges(event) {
    this.setState({
      isLoading: true,
    });
    const localFileContents = this.state.fileContents.data;
    const remainingItems = [];
    const allRoutesToUpload = {};
    for (let i = 0; i < localFileContents.length; i++) {
      const obj = localFileContents[i];
      // group routes together
      if (this.validateline(obj) > 0) {
        const stockingDate = obj.date.toString();
        const route = obj.route.toString().toLowerCase();
        const key = stockingDate + route;
        if (!allRoutesToUpload[key]) {
          allRoutesToUpload[key] = [];
        }

        const routeData = {
          stockingDate: obj.date.toString(),
          market: obj.market.toString(),
          id: obj.id.toString(),
          route: obj.route.toString().toLowerCase(),
          stop: parseInt(obj.stop, 10),
          stockingIndex: parseInt(obj.stockingIndex, 10),
          stopType: obj.stopType.toString().toUpperCase(),
        };

        // Add optional fields if they exist
        if ('calculatedStartTime' in obj) {
          routeData.calculatedStartTime = obj.calculatedStartTime;
        }
        if ('calculatedEndTime' in obj) {
          routeData.calculatedEndTime = obj.calculatedEndTime;
        }

        allRoutesToUpload[key].push(routeData);
      } else if (this.validateline(obj) < 0) {
        remainingItems.push(obj);
      }
    }
    try {
      const uploadedFile = this.state.file.name;
      const uploadResult = await uploadFileToS3(uploadedFile, 'routes-upload');
      // Handle successful upload
    } catch (uploadError) {
      console.error('Error in S3 file upload:', uploadError);
      // Handle upload error
    }

    // TODO: rewrite loop to prevent restricted syntax
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(allRoutesToUpload)) {
      const stopsOnRoute = allRoutesToUpload[key];
      try {
        await CreateLocationRoutes(stopsOnRoute);
      } catch (e) {
        console.error(e);
        stopsOnRoute.forEach((route) => {
          remainingItems.push(route);
        });
      }
    }
    // eslint-disable-next-line react/no-access-state-in-setstate
    const fileContents = this.state.fileContents;
    fileContents.data = remainingItems;
    this.setState({
      fileContents,
      isLoading: false,
    });
  }

  // TODO: rewrite function to prevent param reassigning
  handleFileChange = (event) => {
    this.setState({
      fileContents: '',
    });
    window.Papa.parse(event.target.files[0], {
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        // eslint-disable-next-line no-param-reassign
        results.data = results.data.map((item) => {
          // eslint-disable-next-line no-param-reassign
          item.id = item.id.toString();
          return item;
        });

        this.setState({
          fileContents: results,
        });
      }.bind(this),
    });
    this.setState({
      // TODO: Check if can we safety remove this unused state
      // eslint-disable-next-line react/no-unused-state
      file: event.target.files[0],
    });
  };

  validateline(item) {
    const value = this.getLocationType(item.id);
    if (!value) {
      // location not found in Operations table
      return -1;
    }
    const item_keys = Object.keys(item);
    const keys = [
      'date',
      'market',
      'id',
      'route',
      'stop',
      'stockingIndex',
      'stopType',
    ];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (!item_keys.includes(key)) {
        return -1;
      }
    }

    // Check optional time fields if they exist
    const optionalTimeKeys = ['calculatedStartTime', 'calculatedEndTime'];

    for (let i = 0; i < optionalTimeKeys.length; i++) {
      const timeKey = optionalTimeKeys[i];
      if (item_keys.includes(timeKey)) {
        // Key exists, validate format and date validity
        if (!this.isValidDateTime(item[timeKey])) {
          return -1;
        }
      }
    }

    return 1;
  }

  isValidDateTime(dateTimeString) {
    // Validate format "YYYY-MM-DD HH:MM:SS" with strict parsing
    return moment(dateTimeString, 'YYYY-MM-DD HH:mm:ss', true).isValid();
  }

  validateFile() {
    if (this.state.fileContents === '') {
      return true;
    }
    return false;
  }

  getLocationType(id) {
    const locations =
      this.state.locations &&
      this.state.locations.filter((obj) => {
        return obj.id === id;
      });
    if (locations && locations.length > 0) {
      return locations[0].type;
    }
  }

  render() {
    let headers;
    let rows;
    if (this.state.fileContents !== '') {
      const requiredColumns = [
        'date',
        'market',
        'id',
        'route',
        'stop',
        'stockingIndex',
        'stopType',
      ];

      const optionalColumns = ['calculatedStartTime', 'calculatedEndTime'];

      // Check which optional columns exist in the data
      const firstRow = this.state.fileContents.data[0] || {};
      const displayColumns = [
        ...requiredColumns,
        ...optionalColumns.filter((col) => col in firstRow),
      ];

      headers = [
        ...displayColumns.map((header) => <th key={header}>{header}</th>),
        <th key="status">status</th>,
      ];

      rows = this.state.fileContents.data.map(
        function (obj) {
          const tds = displayColumns.map((header) => (
            <td key={header}>{obj[header]}</td>
          ));

          tds.push(
            <td key="status">
              {' '}
              {this.validateline(obj) > 0 && <Glyphicon glyph="ok" />}
              {this.validateline(obj) < 0 && (
                <Glyphicon glyph="exclamation-sign" />
              )}
            </td>,
          );

          // Build unique key from all displayed columns
          const rowKey = displayColumns.map((col) => obj[col]).join('-');

          return <tr key={rowKey}>{tds}</tr>;
        }.bind(this),
      );
    }

    return (
      <div className="Locations">
        <FormGroup controlId="file">
          <FormControl
            onClick={(event) => {
              // eslint-disable-next-line no-param-reassign
              event.target.value = null;
            }}
            onChange={this.handleFileChange}
            type="file"
          />
        </FormGroup>

        {this.state.fileContents !== '' && (
          <Table bordered responsive>
            <thead>
              <tr>{headers}</tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        )}

        <LoaderButton
          block
          bsStyle="primary"
          bsSize="large"
          disabled={this.validateFile()}
          onClick={this.makeChanges}
          type="submit"
          isLoading={this.state.isLoading}
          text="Upload Drivers"
          loadingText="Uploading Drivers…"
        />
      </div>
    );
  }
}
